import { Directive } from '@angular/core';

/**
 * Styles a native checkbox. A directive, not a component, so [formControlName] and the
 * label's `for` keep working and no wrapper lands in the layout.
 *
 * accent-color rather than a hand-drawn box: it colours the native control in every
 * modern browser and keeps the platform's own focus and checked semantics.
 */
@Directive({
  selector: 'input[type="checkbox"][appCheckbox]',
  host: {
    class:
      'size-5 shrink-0 cursor-pointer rounded border-border bg-surface-raised ' +
      'accent-[var(--color-brand)] ' +
      'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand',
  },
})
export class CheckboxDirective {}
